let activeEl = null;

export function claimMedia(el) {
  if (!el) return;

  // If something else is playing, stop it first
  if (activeEl && activeEl !== el) {
    try { activeEl.pause(); } catch {}
  }

  activeEl = el;

  // When this element ends or is paused by user, release the claim
  const release = () => {
    if (activeEl === el && (el.ended || el.paused)) {
      activeEl = null;
      el.removeEventListener('ended', release);
      el.removeEventListener('pause', release);
    }
  };

  el.addEventListener('ended', release);
  el.addEventListener('pause', release);
}
